module.exports = __webpack_public_path__ + "static/media/nestjs.10650763.svg";